import React from 'react';
import { useLanguage } from '../context/LanguageContext';

export default function Privacyverklaring() {
  const { language } = useLanguage();

  return (
    <div data-testid="privacyverklaring-page">
      <section className="py-32 lg:py-40 bg-white">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          <h1 className="text-3xl sm:text-4xl font-bold text-[#08080A] mb-10" data-testid="privacy-title">
            {language === 'nl' ? 'Privacyverklaring' : 'Privacy Policy'}
          </h1>

          <div className="prose prose-gray max-w-none space-y-6 text-[#555] leading-relaxed">
            <p>
              {language === 'nl'
                ? 'Kesult, gevestigd in Veenendaal, is verantwoordelijk voor de verwerking van persoonsgegevens zoals weergegeven in deze privacyverklaring.'
                : 'Kesult, based in Veenendaal, is responsible for the processing of personal data as described in this privacy policy.'}
            </p>

            <h2 className="text-xl font-bold text-[#08080A] pt-4">
              {language === 'nl' ? 'Persoonsgegevens die wij verwerken' : 'Personal data we process'}
            </h2>
            <p>
              {language === 'nl'
                ? 'Kesult verwerkt persoonsgegevens doordat je gebruik maakt van onze diensten en/of omdat je deze gegevens zelf aan ons verstrekt. Hieronder een overzicht van de persoonsgegevens die wij verwerken:'
                : 'Kesult processes personal data because you use our services and/or because you provide this data to us yourself. Below is an overview of the personal data we process:'}
            </p>
            <ul className="list-disc pl-6 space-y-1">
              <li>{language === 'nl' ? 'Voor- en achternaam' : 'First and last name'}</li>
              <li>{language === 'nl' ? 'E-mailadres' : 'Email address'}</li>
              <li>{language === 'nl' ? 'Telefoonnummer' : 'Phone number'}</li>
              <li>{language === 'nl' ? 'Bedrijfsnaam en website' : 'Company name and website'}</li>
            </ul>

            <h2 className="text-xl font-bold text-[#08080A] pt-4">
              {language === 'nl' ? 'Waarom wij gegevens verwerken' : 'Why we process data'}
            </h2>
            <p>
              {language === 'nl'
                ? 'Kesult verwerkt jouw persoonsgegevens voor de volgende doelen:'
                : 'Kesult processes your personal data for the following purposes:'}
            </p>
            <ul className="list-disc pl-6 space-y-1">
              <li>{language === 'nl' ? 'Om contact met je op te nemen naar aanleiding van een ingevuld formulier' : 'To contact you following a completed form'}</li>
              <li>{language === 'nl' ? 'Om onze dienstverlening te kunnen uitvoeren' : 'To perform our services'}</li>
              <li>{language === 'nl' ? 'Om je te informeren over wijzigingen van onze diensten' : 'To inform you about changes to our services'}</li>
            </ul>

            <h2 className="text-xl font-bold text-[#08080A] pt-4">
              {language === 'nl' ? 'Bewaartermijn' : 'Retention period'}
            </h2>
            <p>
              {language === 'nl'
                ? 'Kesult bewaart je persoonsgegevens niet langer dan strikt noodzakelijk is om de doelen te realiseren waarvoor je gegevens worden verzameld. Wij hanteren een bewaartermijn van maximaal 24 maanden voor contactgegevens.'
                : 'Kesult does not retain your personal data longer than strictly necessary to achieve the purposes for which your data is collected. We apply a maximum retention period of 24 months for contact data.'}
            </p>

            <h2 className="text-xl font-bold text-[#08080A] pt-4">
              {language === 'nl' ? 'Delen met derden' : 'Sharing with third parties'}
            </h2>
            <p>
              {language === 'nl'
                ? 'Kesult verstrekt jouw gegevens niet aan derden, tenzij dit nodig is voor de uitvoering van onze overeenkomst of om te voldoen aan een wettelijke verplichting.'
                : 'Kesult does not share your data with third parties, unless this is necessary for the execution of our agreement or to comply with a legal obligation.'}
            </p>

            <h2 className="text-xl font-bold text-[#08080A] pt-4">
              Cookies
            </h2>
            <p>
              {language === 'nl'
                ? 'Kesult gebruikt alleen technische en functionele cookies. Een cookie is een klein tekstbestand dat bij het eerste bezoek aan deze website wordt opgeslagen op jouw computer, tablet of smartphone. De cookies die wij gebruiken zijn noodzakelijk voor de technische werking van de website.'
                : 'Kesult only uses technical and functional cookies. A cookie is a small text file that is stored on your computer, tablet or smartphone when you first visit this website. The cookies we use are necessary for the technical operation of the website.'}
            </p>

            <h2 className="text-xl font-bold text-[#08080A] pt-4">
              {language === 'nl' ? 'Jouw rechten' : 'Your rights'}
            </h2>
            <p>
              {language === 'nl'
                ? 'Je hebt het recht om je persoonsgegevens in te zien, te corrigeren of te verwijderen. Daarnaast heb je het recht om je eventuele toestemming voor de gegevensverwerking in te trekken of bezwaar te maken tegen de verwerking. Je kunt een verzoek indienen via info@kesult.com.'
                : 'You have the right to access, correct or delete your personal data. In addition, you have the right to withdraw any consent for data processing or to object to the processing. You can submit a request via info@kesult.com.'}
            </p>

            <h2 className="text-xl font-bold text-[#08080A] pt-4">
              {language === 'nl' ? 'Beveiliging' : 'Security'}
            </h2>
            <p>
              {language === 'nl'
                ? 'Kesult neemt de bescherming van jouw gegevens serieus en neemt passende maatregelen om misbruik, verlies, onbevoegde toegang en andere ongewenste handelingen met jouw persoonsgegevens tegen te gaan.'
                : 'Kesult takes the protection of your data seriously and takes appropriate measures to prevent misuse, loss, unauthorized access and other unwanted actions with your personal data.'}
            </p>

            <h2 className="text-xl font-bold text-[#08080A] pt-4">
              {language === 'nl' ? 'Contactgegevens' : 'Contact details'}
            </h2>
            <p>
              {language === 'nl'
                ? 'Als je vragen hebt over deze privacyverklaring, neem dan contact op via:'
                : 'If you have questions about this privacy policy, please contact us at:'}
            </p>
            <p className="text-[#08080A] font-medium">
              Kesult<br />
              info@kesult.com<br />
              KVK 42002486
            </p>

            <div className="pt-6 border-t border-gray-100 mt-8">
              <p className="text-sm text-[#999]">
                {language === 'nl'
                  ? 'Laatst bijgewerkt: maart 2026'
                  : 'Last updated: March 2026'}
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
